import styles from './Main.module.scss';

export interface UI_MainProps {
	header?: React.ReactNode;
	children: React.ReactNode;
}

export const UI_Main = ({ header, children }: UI_MainProps) => (
	<main id="main" className={styles.Main}>
		<article className={styles.Main_article}>
			{header}
			<article className={styles.Main_article}>{children}</article>
		</article>
	</main>
);
